/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsRecommendedProducts = {
    init: function ($section) {
      // Add settings from schema to current object
      Shopify.theme.jsRecommendedProducts = $.extend(
        this,
        Shopify.theme.getSectionData($section)
      );

      // Look for an element with class 'product-recommendations'
      const $productRecommendations = $section.find(".product-recommendations");

      // Selectors
      const productID = $productRecommendations.data("product-id");
      const limit = $productRecommendations.data("limit");
      const sectionID = $productRecommendations.data("section-id");

      // If showing custom collection we do not want to build request url
      if (this.show_custom_collection) {
        this.showCustomCollection($section);
        return;
      }

      // Build request URL
      const shopURL = $productRecommendations.data("base-url");
      const requestUrl = `${shopURL}?section_id=${sectionID}&limit=${limit}&product_id=${productID}`;

      $.ajax({
        type: "GET",
        url: requestUrl,
        success: function (data) {
          let $recommendedProductsElement = $(data)
            .find(".product-recommendations")
            .html();

          if (!$recommendedProductsElement.trim().length) {
            $section.hide();
            console.warn("No Recommendations Found. Hiding The Section");
            return;
          }

          // Insert product list into the product recommendations container
          $productRecommendations.html($recommendedProductsElement);

          Shopify.theme.jsProduct.relatedProducts($section);

          // Initialize Shopify payment buttons
          if (Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          // Convert currencies if needed
          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }

          // ✅ Initialize Flickity for mobile after products are loaded
          if (window.innerWidth < 799) {
            $(".product-recommendations-row").flickity({
              cellAlign: "left",
              contain: true,
              draggable: true,
              prevNextButtons: false,
              pageDots: true,
            });
          }
        },
      });
    },
    showCustomCollection: function ($section) {
      const $recommendedProductsElement = $section
        .find(".product-recommendations")
        .html();

      const $productRecommendationsContainer = $(".product-recommendations");
      $productRecommendationsContainer.html($recommendedProductsElement);

      Shopify.theme.jsProduct.relatedProducts($section);

      // ✅ Initialize Flickity for mobile in custom collection as well
      if (window.innerWidth < 799) {
        $(".product-recommendations-row").flickity({
          cellAlign: "left",
          contain: true,
          draggable: true,
          prevNextButtons: false,
          pageDots: true,
        });
      }
    },
    unload: function ($section) {},
  };
  /******/
})();
